
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.76","height":"18.102"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1388.486 -499.414)","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1398.326 508.933a5.379 5.379 0 10-7.862.063 5.115 5.115 0 011.372 3.529v3.024a1.467 1.467 0 001.467 1.467h2.126a1.467 1.467 0 001.468-1.467v-1.742h0v-1.283a5.313 5.313 0 011.429-3.591z"}}),_c('line',{attrs:{"x2":"5.058","transform":"translate(1391.838 513.615)"}})])])
          )
        }
      }
    